// extracted by mini-css-extract-plugin
module.exports = {"title":"az_TLc","separator":"az_ULc"};